import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";

const TimePicker = ({ formik, label, interval = 15, disabled }) => {
  const [customTime, setCustomTime] = useState(formik?.values?.fromTime || "");

  useEffect(() => {
    if (formik?.values?.[label]) {
      setCustomTime(formik?.values?.[label]);
    }
  }, [formik?.values?.[label]]);

  const generateTimeOptions = () => {
    const times = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += interval) {
        const hour = h % 12 === 0 ? 12 : h % 12;
        const period = h < 12 ? "AM" : "PM";
        const minute = String(m).padStart(2, "0");
        const time = `${String(hour).padStart(2, "0")}:${minute} ${period}`;
        const value = `${String(h).padStart(2, "0")}:${minute}`;
        times.push({ label: time, value });
      }
    }
    return times;
  };

  const handleTimeChange = (event) => {
    const value = event.target.value;
    setCustomTime(value);
    formik.setFieldValue(label, value);
  };

  return (
    <>
      <Input
        type="time"
        name="fromTime"
        value={customTime}
        onChange={handleTimeChange}
        list="time-options"
        style={{
          border: "1px solid #d1d1d1ce",
          backgroundColor: "#ffffff",
        }}
        disabled={disabled}
      />
      <datalist id="time-options">
        {generateTimeOptions().map((time) => (
          <option key={time.value} value={time.value}>
            {/* {time.label} */}
          </option>
        ))}
      </datalist>
    </>
  );
};

export default TimePicker;
